import React from "react";
import { useTranslation } from "react-i18next";
import { useHref } from "react-router-dom";
import { QBox, QCenter, QIconButton, QTooltip } from "@qualio/ui-components";

type Props = {
  to: string;
};

export const ReviewItemCompareButton: React.FC<Props> = ({ to }) => {
  const { t } = useTranslation();
  const href = useHref(to);

  return (
    <QCenter>
      <QTooltip label={t("common.ariaLabels.seeDifference")}>
        <QBox data-cy="review-item-compare">
          <QIconButton
            iconName="GitPullRequest"
            aria-label={t("common.ariaLabels.seeDifferenceBetweenVersion")}
            onClick={() => window.open(href, "_blank", "noopener")}
          />
        </QBox>
      </QTooltip>
    </QCenter>
  );
};
